import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import IndicacoesBIGE from '../pages/biGE/indicacoes';
import ConversaoLPs from '../pages/crm/conversaoLPs';
import CrmCupons from '../pages/crm/cupons';
import CrmDashboard from '../pages/crm/crmDashboard';
import CrmLeadContract from '../pages/crm/crmLeadContract';
import CrmLeadDetails from '../pages/crm/crmLeadDetails';
import CrmLeads from '../pages/crm/crmLeads';
import MarketingDashboard from '../pages/crm/marketingDashboard';
import GenerateAdditive from '../pages/gestaoEnergia/generateAdditive';

const RouteCRM = ({ isMobile = false }) => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='CRM'/>}>
                <Route path='dashboard' element={<CrmDashboard isMobile={isMobile}/>}/>
            </Route>
            <Route element={<ProtectedRoute roles={['CRM', 'Relacionamento', 'Cobranca']}/>}>
                <Route path='leads' element={<CrmLeads/>}/>
                <Route path='leads/:leadId' element={<CrmLeadDetails/>}/>
                <Route path='generateAdditive' element={<GenerateAdditive/>}/>
            </Route>
            <Route element={<ProtectedRoute role='Comercial'/>}>
                <Route path='leads/:leadId/contrato' element={<CrmLeadContract/>}/>
            </Route>
            <Route element={<ProtectedRoute role='MKT'/>}>
                <Route path='marketing-dashboard' element={<MarketingDashboard/>}/>
                <Route path='conversao-lps' element={<ConversaoLPs/>}/>
                <Route path='cupons' element={<CrmCupons/>}/>
                <Route path='indicacoes' element={<IndicacoesBIGE/>}/>
            </Route>
        </Routes>
    );
};

export default RouteCRM;
